import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/weight-loss/medicals',
)({
  component: () => (
    <main
      role="main"
      aria-label="medicals content"
      className="min-h-screen w-full"
    >
      <Outlet />
    </main>
  ),
  errorComponent: ({ error }: { error: Error }) => (
    <div
      role="alert"
      className="flex min-h-screen items-center justify-center p-4"
    >
      <div className="text-center">
        <h1 className="text-2xl font-bold">Dashboard error medicals</h1>
        <pre className="mt-4">{error.message}</pre>
      </div>
    </div>
  ),
})

